// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorModal_container__9wIMl","header":"ErrorModal_header__jiBQu","title":"ErrorModal_title__Pr4Ji","body":"ErrorModal_body__U73ex","footer":"ErrorModal_footer__A7xPG"};